// add redirect here
import { NOT_FOUND } from 'redux-first-router';
import { fetchData } from './utils';

const handleDispatch = (dispatch, type, data) => (data === null ? dispatch({ type: NOT_FOUND })
  : dispatch({ type, payload: { data } }));

// might want to group related routes together and import them instead (ex. gift-guide ones)
export default {
  
  DEFAULT: {
    path: '/',
    thunk: async (dispatch) => {
      dispatch({ type: 'HOME_FETCHED' });
    },
  },

  HOME: {
    path: '/20-in-20',
    thunk: async (dispatch) => {
      dispatch({ type: 'HOME_FETCHED' });
    },
  },
  
  DEFAULT_SLIDESHOW: {
    path: '/slideshow',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'SLIDESHOW_FETCHING' });
      const {
        location: {
          payload: {
            slide,
          },
        },
      } = getState();
      const data = await fetchData(`/api/slideshow/${slide}`);
      handleDispatch(dispatch, 'SLIDESHOW_FETCHED', data);
    },
  },

  SLIDESHOW: {
    path: '/20-in-20/slideshow',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'SLIDESHOW_FETCHING' });
      const {
        location: {
          payload: {
            slide,
          },
        },
      } = getState();
      const data = await fetchData(`/api/slideshow/${slide}`);
      handleDispatch(dispatch, 'SLIDESHOW_FETCHED', data);
    },
  },

  DEFAULT_LANDER: {
    path: '/honorees',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'LANDER_FETCHING' });
      const data = await fetchData(`/api/honorees`);
      handleDispatch(dispatch, 'LANDER_FETCHED', data);
    },
  },

  LANDER: {
    path: '/20-in-20/honorees',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'LANDER_FETCHING' });
      const data = await fetchData(`/api/honorees`);
      handleDispatch(dispatch, 'LANDER_FETCHED', data);
    },
  },

  DEFAULT_HONOREE: {
    path: '/honorees/:honoree',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'ARTICLE_FETCHING' });
      const {
        location: {
          payload: {
            honoree,
          },
        },
      } = getState();

      // figure out how to pull query string from location.payload (might be a redux-first-router thing)
      const data = await fetchData(`/api/honorees/${honoree}`);
      handleDispatch(dispatch, 'ARTICLE_FETCHED', data);
    },
  },

  HONOREE: {
    path: '/20-in-20/honorees/:honoree',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'ARTICLE_FETCHING' });
      const {
        location: {
          payload: {
            honoree,
          },
        },
      } = getState();

      // figure out how to pull query string from location.payload (might be a redux-first-router thing)
      const data = await fetchData(`/api/honorees/${honoree}`);
      handleDispatch(dispatch, 'ARTICLE_FETCHED', data);
    },
  },

  DEFAULT_COMMITTEE: {
    path: '/committee',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'COMMITTEE_FETCHING' });
      const data = await fetchData(`/api/committee`);
      handleDispatch(dispatch, 'COMMITTEE_FETCHED', data);
    },
  },

  COMMITTEE: {
    path: '/20-in-20/committee',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'COMMITTEE_FETCHING' });
      const data = await fetchData(`/api/committee`);
      handleDispatch(dispatch, 'COMMITTEE_FETCHED', data);
    },
  },
};
